var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogleLogo = function SvgGoogleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#googleLogo_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M26.314 13.295c0-.921-.083-1.808-.237-2.659H13.833v5.029h6.997a5.98 5.98 0 0 1-2.594 3.924v3.261h4.201c2.458-2.263 3.877-5.596 3.877-9.555"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M13.833 26c3.51 0 6.453-1.164 8.604-3.15l-4.202-3.262c-1.164.78-2.653 1.241-4.402 1.241-3.386 0-6.252-2.286-7.274-5.36H2.216v3.369A13 13 0 0 0 13.833 26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M6.56 15.47A7.8 7.8 0 0 1 6.151 13c0-.857.147-1.69.407-2.47V7.162H2.216A13 13 0 0 0 .833 13c0 2.098.503 4.084 1.383 5.839z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M13.833 5.17c1.909 0 3.622.656 4.97 1.945l3.728-3.73C20.28 1.289 17.337 0 13.833 0A13 13 0 0 0 2.216 7.162l4.343 3.368c1.022-3.073 3.888-5.36 7.274-5.36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "googleLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.833 0h26v26h-26z"
  })))));
};
export default SvgGoogleLogo;